import { render, staticRenderFns } from "./AddAccountDetailsModal.vue?vue&type=template&id=0c3d2276&scoped=true"
import script from "./AddAccountDetailsModal.vue?vue&type=script&lang=js"
export * from "./AddAccountDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d2276",
  null
  
)

export default component.exports